import React, { useState, useRef, useEffect } from 'react';
import CredlixAgent from '../credlixAgent/CredlixAgentSDK';
import credlixAgentConfig from '@/config/credlixAgent_config';

const TalkToAI = ({ formData, onClose }) => {
    const [isCalling, setIsCalling] = useState(false);
    const agentRef = useRef(null);
    const hasCalledRef = useRef(false);

    useEffect(() => {
        return () => {
            if (agentRef.current) {
                agentRef.current.destroy();
                agentRef.current = null;
            }
        };
    }, []);

    const handleTalkToAI = async () => {
        try {
            if (agentRef.current) {
                agentRef.current.destroy();
                agentRef.current = null;
            }
            setIsCalling(true);
            hasCalledRef.current = false;
            const workflowId = process.env.EXIM_AI_VOXERA_WORKFLOWId || credlixAgentConfig.workflowId;
            const userName = formData?.Name || formData?.name || formData?.companyName;
            const phoneNumber = formData?.phoneNumber || '+919999999999';

            const agent = new CredlixAgent({
                ...credlixAgentConfig,
                workflowId,
                userName,
                phoneNumber,
                renderWidget: true,
                showNotifications: true,
                showFloatingButton: false,
                onStateChange: (state) => {
                    if (state === 'connecting' || state === 'active') {
                        hasCalledRef.current = true;
                    }
                    if (state === 'idle') {
                        setIsCalling(false);
                        if (hasCalledRef.current) {
                            hasCalledRef.current = false;
                            if (onClose) {
                                onClose();
                            }
                        }
                    }
                },
                onError: (type, err) => {
                    console.error(`[AI Agent Error] ${type}:`, err);
                    setIsCalling(false);
                    if (hasCalledRef.current && onClose) {
                        hasCalledRef.current = false;
                        onClose();
                    }
                },
            });

            agentRef.current = agent;
            await agent.startCall();
        } catch (error) {
            console.error('Error starting AI call:', error);
            setIsCalling(false);
        }
    };

    return (
        <div className="text-center py-2">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full mb-2 bg-green-50">
                <svg className="h-6 w-6 text-[#008000]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
            </div>
            <h3 className="text-lg font-semibold text-[#008000] mb-2">
                Thank You!
            </h3>
            <p className="text-sm text-gray-600 mb-2">
                Your details have been submitted successfully.
            </p>
            <p className="text-base2 text-black font-medium mb-5">
                You can now talk to our AI Assistant for further assistance.
            </p>
            <button
                type="button"
                onClick={handleTalkToAI}
                disabled={isCalling}
                className="w-full py-2 rounded-lg text-white font-medium text-base shadow-md transition-all duration-300 ease-in-out bg-gradient-to-r from-[#022B5C] to-[#0363C4] hover:from-[#0363C4] hover:to-[#022B5C] active:scale-[0.98] disabled:opacity-60 cursor-pointer"
            >
                {isCalling ? 'Connecting to AI Assistant...' : 'Talk to our AI Assistant Now'}
            </button>
        </div>
    );
};

export default TalkToAI;
